import { shareAction } from '../actions/share'
import { shareMutation } from '../mutations/share'

export const share = {
  state: {
    status: false,
    initLink: ''
  },
  mutations: shareMutation,
  actions: shareAction
}
